import React from "react";

function TextCard({ title, desc , post_author ,post_date}) {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    };
  return (
    <>
      <h2 className="fw-bold h5 hoverHead  mt-3">{title}</h2>

      <p className="mt-1" style={{ fontSize: "12px" }}>
      By <span className="fw-bold">{post_author}</span> | {new Date(post_date).toLocaleDateString(undefined, options) }   
      </p>
      <p className="just-text line-clamp  mt-1" style={{ fontSize: "15px" }}>
        {desc}
      </p>
     
    </>
  );
}

export default React.memo(TextCard);
